import React, { useEffect } from 'react';
import { RegisterForm } from '@/components/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/store';


const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Don't render anything while checking auth or if already authenticated
  if (loading || isAuthenticated) {
    return null;
  }

  return <RegisterForm />;
};

export default RegisterPage;
